import React from "react";
import { Button, Icon, Popup } from "semantic-ui-react";
import { useAuth } from "../../../../hooks";

export function Logout() {
  const { logout } = useAuth();

  const onLogout = () => {
    logout();
  };

  return (
    <Popup
      content="Cerrar sesión"
      trigger={
        <Button icon floated="right" size="large" color="red" onClick={onLogout}>
          <Icon name="sign-out alternate" />
        </Button>
      }
    />
  );
}
